import { attributes } from 'state/product/config/DOM/attributes'

export const nodes = {
  /*  -------- Product Container --------  */
  class: {
    container: document.getElementById('productContainer'), // Product container (all products)
    count: document.getElementById('h1-element') // Active product count in the H1 title
  },

  color: {
    image: document.createElement('img'),
    swatch: document.createElement('img')
  },

  /*  -------- Product Instances --------  */
  instance: {
    container: document.createElement('li'),
    span: document.createElement('span'),
    // image: document.createElement('img'),
    imageLink: document.createElement('a'),
    link: document.createElement('a'),
    priceContainer: document.createElement('span'),
    price: document.createElement('p'),
    rating: document.createElement('div'),
    // reviewCount: document.createElement('i'),
    salePrice: document.createElement('p'),
    swatchContainer: document.createElement('ul'),
    // swatch: document.createElement('img'),
    title: document.createElement('h4')
  }
}

// Assign default attributes to DOM nodes
for (let [nodeName, properties] of Object.entries(attributes.color)) {
  Object.assign(nodes.color[nodeName], properties)
}

for (let [nodeName, properties] of Object.entries(attributes.instance)) {
  Object.assign(nodes.instance[nodeName], properties)
}

// module.exports = Object.freeze(nodes)